import { useLang } from "@/context";
import { Chapter, Reveal } from "@/components/Reveal";

export default function Languages() {
  const { t } = useLang();

  return (
    <section data-testid="languages-section" className="pb-28 sm:pb-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <Chapter number="—" label={t.languages.label} />
        <div className="grid grid-cols-12 gap-y-10 lg:gap-10">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <h2
                data-testid="languages-title"
                className="font-serif text-4xl sm:text-5xl text-charcoal font-medium leading-[1.1]"
              >
                {t.languages.title}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p
                data-testid="languages-note"
                className="mt-6 max-w-sm text-sm sm:text-base text-ink/65 leading-relaxed font-light"
              >
                {t.languages.note}
              </p>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-7">
            {t.languages.items.map((l, i) => (
              <Reveal key={l.name} delay={i * 0.06} y={16}>
                <div
                  data-testid={`language-${l.name.toLowerCase()}`}
                  className="group flex items-baseline justify-between border-t border-taupe/25 py-5 sm:py-6"
                >
                  <span className="font-serif text-2xl sm:text-3xl text-charcoal font-medium transition-transform duration-500 group-hover:translate-x-2">
                    {l.name}
                  </span>
                  <span className="text-xs sm:text-sm tracking-[0.3em] text-taupe group-hover:text-gold transition-colors duration-500">
                    {l.level}
                  </span>
                </div>
              </Reveal>
            ))}
            <div className="border-t border-taupe/25" />
          </div>
        </div>
      </div>
    </section>
  );
}
